import { EntitiesStore } from './entities-store.abstract';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';


/**
 * Athlete of open ranking.
 *
 * @interface Athlete
 */
interface Athlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * Team of open ranking.
 *
 * @interface Team
 */
interface Team {
  TeamId: string;
  TeamName: string;
  TeamCatId: string;
}

/**
 * Detail of open ranking.
 *
 * @interface Detail
 */
interface Detail {
  ID: string;
  Name: string;
  NameShort: string;
  Place: string;
  Country: string;
  Date: string;
  Position: number;
  Score: number;
  Stage: number;
  inTotal: boolean;
}


/**
 * Indoor open ranking store.
 *
 * @export
 * @interface IOpenRankingSModel
 */
export interface IOpenRankingSModel {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Score: number;
  Athlete: Athlete;
  Team: Team;
  Details: Detail[];
}

/**
 * Indoor open ranking store.
 *
 * @export
 * @class OpenRankingIndoorStore
 * @extends {EntitiesStore<IOpenRankingSModel>}
 */
export class OpenRankingIndoorStore extends EntitiesStore<IOpenRankingSModel> {
  constructor(injector: Injector) {
    super('SERIESAMATEURSRANKINGS', injector.get(HttpClient));
  }
}
